import { ReceiptRequest, WalletMockService } from "@/services/backend";
import { Message, MessagingService } from "@/services/messaging";
import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { CheckoutRequest } from "../checkout";
import { Center, Card, Flex, Image, useMantineTheme, Text, Loader, Stack, Button } from "@mantine/core";

const mService = new MessagingService(window.parent);
const ws_url = process.env.REACT_APP_WALLET_WSS || 'ws://localhost:3000';
export interface AgentWSMessage {
    type: string;
    authn_url?: string;
    image?: string;
    message?: string;
    order?: string;
}

export function AgentCheckout() {
    const [payload, setPayload] = useState<CheckoutRequest | null>(null);
    const [redirect, setRedirect] = useState<boolean>(false);
    const [authnUrl, setAuthnUrl] = useState<string | null>(null);
    const [phase, setPhase] = useState<string>("creating checkout cart at merchant");
    const [cr, setCR] = useState<CheckoutRequest | null>(null);
    //const [ws, setWs] = useState<WebSocket | null>(null);
    useEffect(() => {

        const inIframe = window.self !== window.top;

        if (inIframe) {
            mService.onMessage((msg, origin) => onMessageHandle(msg, origin));
        } else {
            setRedirect(true);
            console.log("resize");
            window.self.resizeTo(400, 800);
        }


        const checkoutId = params.id;
        console.log(ws_url + "/agent");
        const websocket = new WebSocket(ws_url + "/agent");
        websocket.onmessage = async (event) => {
            // handle event.data
            console.log(event.data);
            const message: AgentWSMessage = JSON.parse(event.data);
            if (message.type === "auth-init" && message.authn_url) {
                setAuthnUrl(message.authn_url)
                //document.location.href = message.auth_url;
            } else if (message.type === "auth-complete") {
                setAuthnUrl(null)
                setPhase("auth complete waiting for payment confirmation")
            } else if (message.type === "cart-complete") {
                setAuthnUrl(null)
                setPhase("checkout cart complete - proceeding to payment")
            } else if (message.type === "order-complete") {
                setAuthnUrl(null)
                setPhase(`checkout complete - ${message.order}`)
                if (checkoutId) {
                    const receipt: ReceiptRequest = {
                        id: message.order || "",
                        cid: checkoutId,
                        orderId: message.order || "",
                        at: new Date().toLocaleDateString(),
                    }
                    await WalletMockService.storeReceipt(receipt);
                    mService.sendMessageData({ id: checkoutId, token: message.order, passkey: true });
                } else {
                    mService.sendMessageData({ id: "", passkey: false, error: "checkout error" });
                }
            }
        }
        websocket.onopen = () => {
            console.log("send message " + checkoutId);
            if (checkoutId) {
                websocket.send(checkoutId);
            }
        }
        websocket.onclose = () => console.log("close socket?");
        if (checkoutId) {
            try {
                WalletMockService.startAgent(checkoutId).then((checkout) => {
                    setCR(checkout);
                });
            } catch (error) {
                console.log(error);
            }
        }
        //setWs(websocket);
        /*
        if (checkoutId) {
            console.log("load order");
            console.log("after load order");
        }
            */


        return () => websocket.close()
    }, []);

    //const [searchParams] = useSearchParams();
    let params = useParams();
    async function loadOrder() {
        //const checkoutId = searchParams.get("token");
        const checkoutId = params.id;
        let apayload = null;
        console.log("load order ", checkoutId);

    }

    function onMessageHandle(msg: Message, origin: string) { }
    function handleCancel() {
        mService.sendMessageData({ id: "", passkey: false, error: "user cancel" });
    }

    return (
        <Center h="100vh" w="100%">
            {authnUrl == null &&
                <Stack justify="center" align="center">
                    <Text>{phase}</Text>
                    <Loader size={50} />
                    <Button onClick={handleCancel}>Cancel</Button>
                </Stack>
            }
            {authnUrl &&
                <iframe src={authnUrl} width="100%" style={{ height: "100%" }} frameBorder="0" allow="publickey-credentials-get *; publickey-credentials-create * ;"></iframe>
            }
        </Center>
    );
}